export const allowedLanguages = {
  AE: "ae",
};

export const languages = ["ae", "en"];

export const defaultLanguage = "en";
